import { useAuthStore } from '../../store/auth.store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute() {
  const { isAuthenticated, hasRehydrated, isLoading, checkAuth, token } = useAuthStore();
  const location = useLocation();

  // Check auth on mount (but only after rehydration)
  useEffect(() => {
    if (hasRehydrated) {
      checkAuth();
    }
  }, [hasRehydrated, checkAuth]);

  // Wait for rehydration to complete before making any decisions
  if (!hasRehydrated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-12 w-12 animate-spin text-purple-500" />
          <p className="text-sm text-light-text-muted dark:text-dark-text-muted">Loading...</p>
        </div>
      </div>
    );
  }

  // If loading auth check, show loading
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-12 w-12 animate-spin text-purple-500" />
          <p className="text-sm text-light-text-muted dark:text-dark-text-muted">Verifying session...</p>
        </div>
      </div>
    );
  }

  // After checkAuth resolves — if still not authenticated, redirect
  if (!isAuthenticated && !token) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  // Fallback: if we have a token but isAuthenticated somehow false, trust the token
  if (!isAuthenticated && token) {
    return <Outlet />;
  }

  return <Outlet />;
}
